import { useRef, useState, useLayoutEffect, useEffect } from "react";

function HeadingWithNubbon({ text }) {
    const containerRef = useRef(null);
    const headingRef = useRef(null);
    const [nubbonWidth, setNubbonWidth] = useState(null); // null = don't apply

    const update = () => {
        const isMobile = window.innerWidth <= 544;

        // If NOT mobile → remove inline width so CSS wins
        if (!isMobile) {
            setNubbonWidth(null);
            return;
        }

        if (!containerRef.current || !headingRef.current) return;

        const containerWidth = containerRef.current.offsetWidth;
        const headingWidth = headingRef.current.offsetWidth;

        const w = Math.max((containerWidth - headingWidth) / 2 + 14, 0);
        setNubbonWidth(w);
    };

    useLayoutEffect(() => {
        update();
        window.addEventListener("resize", update);
        return () => window.removeEventListener("resize", update);
    }, [text]);

    useEffect(() => {
        // Force an update after the component has fully mounted
        update();
    }, []);

    return (
        <div className="projects-heading-container" ref={containerRef}>
            <div
                className="nubbon"
                style={
                    nubbonWidth !== null ? { width: nubbonWidth } : undefined
                }
            />
            <h1 className="projects-heading" ref={headingRef}>
                {text}
            </h1>
        </div>
    );
}

export default HeadingWithNubbon;
